import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const complianceReportApi = createAsyncThunk(
  "complianceReport",
  // async () => {
  //   const response = await axiosInstance.get("/report/compliance");
  //   return response.data;
  // }

  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};
    if (name) {
      params.name = name;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/compliance", {
      params, 
    });
    if (response) {
      return response.data;
    }
  }
);

const complianceReportSlice = createSlice({
  name: "complianceReport",
  initialState: {
    complianceReport: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(complianceReportApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(complianceReportApi.fulfilled, (state, action) => {
        state.complianceReport = action.payload;
        state.loading = false;
      })
      .addCase(complianceReportApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default complianceReportSlice.reducer;
